// extracted by mini-css-extract-plugin
export default {"image":"SX58k5"};